import { Flex, FlexProps } from '@mantine/core'
import React from 'react'

interface ICustomContainer extends FlexProps {}
const ClientPageLayout = ({ children, ...others }: ICustomContainer) => {
    return (
        <Flex
            direction='column'
            maw='100%'
            miw='100%'
            mih='100vh'
            style={{ overflow: 'hidden' }}
            {...others}
        >
            {children}
        </Flex>
    )
}

export default ClientPageLayout
